import React from "react";
import { motion } from "framer-motion";

export default function Marquee() {
  const items = ["Buy", "Sell", "Trade"];
  const line = new Array(8).fill(0).flatMap((_, i) => items.map((w) => `${w}`));
  return (
    <section
      data-testid="marquee-section"
      className="relative border-y border-[#1c1c1c] bg-[#0A0A0A] overflow-hidden"
      aria-hidden="true"
    >
      <div className="py-8 lg:py-10">
        <div className="marquee-track font-anton uppercase text-[10vw] lg:text-[7.5vw] leading-none">
          {[...line, ...line].map((w, i) => (
            <span key={i} className="mx-8 inline-flex items-center gap-8">
              <span className={i % 3 === 1 ? "text-[#E31E24] italic font-cormorant font-medium" : "text-white"}>
                {w}
              </span>
              <span className="text-[#E31E24]">·</span>
            </span>
          ))}
        </div>
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-40 bg-gradient-to-r from-[#0A0A0A] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-40 bg-gradient-to-l from-[#0A0A0A] to-transparent" />
    </section>
  );
}
